import Script from 'next/script';

export const GoogleEnhancedConversion = () => {
  //minified at https://www.toptal.com/developers/javascript-minifier
  const basecode = `
      // async function digestMessage(message) {
      //   const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
      //   const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
      //   const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
      //   const hashHex = hashArray
      //     .map((b) => b.toString(16).padStart(2, '0'))
      //     .join(''); // convert bytes to hex string
      //   return hashHex;
      // }
      // function getSendLayer(valueH){
      //   var hashedItem =  digestMessage(valueH).then(function(result) {
      //     try {
      //       sessionStorage.setItem("uid-ls-tkad", result);
      //     } catch(e) {
      //     } finally {
      //       window.location ='//' + window.location.host + '/thank-you/contact-home/';
      //     }
      //   });
      // }



      function getSendLayer(valueH){
        try {
          sessionStorage.setItem("uid-ls-tkad", valueH);
        } catch(e) {
        } finally {
          window.location ='//' + window.location.host + '/thank-you/contact-home/';
        }
      }

      //on submit
      window.addEventListener('hs-form-event:on-submission:success', (event) => {
        var inputVal = HubSpotFormsV4.getForms()[0].getFieldValue('0-1/email').then((value) => getSendLayer(value));
      });   
`;
  return (
    <>
      <Script
        id="google-enhanced-conversion-scripts"
        strategy="afterInteractive"
      >
        {`function getSendLayer(e){try{sessionStorage.setItem("uid-ls-tkad",e)}catch(t){}finally{window.location="//"+window.location.host+"/thank-you/contact-home/"}}window.addEventListener("hs-form-event:on-submission:success",e=>{var t=HubSpotFormsV4.getForms()[0].getFieldValue("0-1/email").then(e=>getSendLayer(e))});`}
      </Script>
    </>
  );
};
